import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";
import { connect } from 'react-redux';
import ReactResizeDetector from 'react-resize-detector';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { hasPermission } from '../../store/apiWrapper';
import { chartActions } from '../../store/charts/chartsStore';
import { GRAPH_MODE, GRAPH_TYPE } from '../../store/charts/common/constants';
import { chartExportTypes } from '../../store/charts/exports/initial';
import { popupActions } from '../../store/popupStore';
import { rightPanelStoreActions } from '../../store/rightPanelStore';
import { isNullOrUndefined, validateInput } from '../../store/storeFunctions';
import BbPopover from '../common/popover';
import ChartTopPanelTools from './chartTopPanelTools';

import LoadIcon from '../../img/icons/rc_load';
import RefreshIcon from '../../img/icons/rc_refresh';
import SaveIcon from '../../img/icons/rc_save';
import SaveAsIcon from '../../img/icons/rc_save_as';

class ChartTopPanelComponent extends React.Component {
    doubleClickHookTimestamp = null;

    state = {
        maxInnerWidth: 0
    }

    render() {
        const allTools = [
            { toolId: "toggleTopPanel", component: this.renderCollapseTopPanel() },
            { toolId: "displayOptions1", component: this.renderDisplayOptions1() },
            { toolId: "graphType", component: this.renderGraphType() },
            { toolId: "tools", component: this.renderTools() },
            { toolId: "displayOptions2", component: this.renderDisplayOptions2() },
            { toolId: "profiles", component: this.renderProfileSelection() },
            { toolId: "visualizations", component: this.renderVisualization() },
            { toolId: "exports", component: this.renderExport() },
            { toolId: "exports2", component: this.renderExport2() },
            { toolId: "legend", component: this.renderLegend() },
        ];

        return (
            <div id="topSidePanelWrapper" className="row m-0" style={{ boxShadow: '0 0 4px rgba(177, 177, 177, 0.75)' }} data-html2canvas-ignore>
                <ReactResizeDetector handleHeight onResize={this.props.updateTopPanelHeight}><>
                    <div id="topSidePanel" className="column" style={{ padding: 0, display: this.props.topPanel.expanded ? 'block' : 'none' }}>
                        <ReactResizeDetector handleWidth refreshMode='debounce' refreshRate={100} onResize={this.onResize} />
                        <div className="toolbox-tools" style={{ display: 'flex', justifyContent: "space-between" }}>
                            <ChartTopPanelTools allTools={allTools} maxTableWidth={this.state.maxInnerWidth - 70} />
                            <div><div>{this.renderRightPanel()}</div></div>
                        </div>
                    </div>
                    <div id="topSidePanelOpener" style={{ display: this.props.topPanel.expanded ? 'none' : '', width: '100%' }}>
                        <div className="panel-toggle-open" style={{ height: '12px', width: '12px' }}>
                            <a onClick={_ => this.props.toggleTopPanel(true)} style={{ display: 'grid', float: 'right', padding: '0 0 0 2px' }}>
                                <span className="rc-button rc-expand-menu-btn rc-button-r270" style={{ marginTop: '2px' }}></span>
                            </a>
                        </div>
                    </div>
                </></ReactResizeDetector>
            </div>
        );
    }

    onResize = (width, height) => {
        this.setState({ maxInnerWidth: width });
    }

    renderCollapseTopPanel = () => (
        <div className="panel-toggle-close toolbox-group hidden-xs" style={{ height: '57px', padding: 0, width: '12px', borderRightColor: '#e0e0e0' }}>
            <a onClick={_ => this.props.toggleTopPanel(false)}>
                <span className="rc-button rc-collapse-menu-btn rc-button-r270"></span>
            </a>
        </div>
    )

    renderDisplayOptions1 = () => (
        <div className="toolbox-group" id="targetGroup">
            <p className="panel-name hidden-xs"><Translate id="Charts.DisplayOptions" /></p>
            <div className="content">
                <a onClick={() => this.props.changeZoom('down')}><span className="rc-button rc-minus-circled hidden-xs" style={{ paddingTop: '4px' }}></span></a>
                <input type="text" id="zoomTextBox" onBlur={() => this.props.changeZoom('exact')} onKeyPress={e => { if (e.which === 13) { e.target.blur(); } return false; }} className="rc-button-frame hidden-xs" style={{ width: '50px', textAlign: 'center' }} onInput={(e) => validateInput(e)} defaultValue="100%" />
                <a onClick={() => this.props.changeZoom('up')}><span className="rc-button rc-plus-circled hidden-xs" style={{ paddingTop: '4px' }}></span></a>
                <a className="rc-button-frame hidden-xs" onClick={() => this.props.changeZoom('fit')} style={{ marginLeft: '15px' }}><span className="rc-button icon-rc rc-full-screen"></span></a>
                <a className="rc-button-frame rc-button-text hidden-xs" onClick={() => this.props.changeZoom('100')} style={{ width: '32px', textAlign: 'center', letterSpacing: '-1px', fontSize: '20px' }}><span style={{ left: '-1px' }}>1:1</span></a>
                <a className="rc-button-frame mobile-icon hidden-sm hidden-md hidden-lg" onClick={() => this.props.changeZoom('root')} style={{ width: '43px' }}>
                    <img src="/img/charts/targetHome.svg" width="34" height="34" style={{ top: '-2px', left: '2px', position: 'relative' }} />
                </a>
                <a className="rc-button-frame mobile-icon" onClick={() => this.props.changeZoom('selected')}><span className="rc-button icon-rc rc-selected-subject"></span></a>
            </div>
        </div>
    )

    renderGraphType = () => (
        <div className="toolbox-group" id="graphTypeGroup">
            <p className="panel-name hidden-xs"><Translate id="Charts.GraphType" /></p>
            <div id="typeController" className="content">
                <a className={`rc-button-frame rc-checkbox ${this.props.topPanel.graphType === GRAPH_TYPE.star ? 'checked' : ''} mobile-icon`} group="types" group-value={GRAPH_TYPE.star} title={this.props.translate("Charts.GraphStar")} onClick={this.props.changeGraphType}><span className="rc-button icon-rc rc-chart-star" style={{ padding: '1px 1px 0 1px' }}></span></a>
                <a className={`rc-button-frame rc-checkbox ${this.props.topPanel.graphType === GRAPH_TYPE.tree ? 'checked' : ''} mobile-icon`} group="types" group-value={GRAPH_TYPE.tree} title={this.props.translate("Charts.GraphTree")} onClick={this.props.changeGraphType}><span className="rc-button icon-rc rc-chart-tree" style={{ padding: '1px 1px 0 1px' }}></span></a>
                <a className={`rc-button-frame rc-checkbox ${this.props.topPanel.graphType === GRAPH_TYPE.branch ? 'checked' : ''} mobile-icon`} group="types" group-value={GRAPH_TYPE.branch} title={this.props.translate("Charts.GraphBranch")} onClick={this.props.changeGraphType}><span className="rc-button icon-rc rc-chart-list" style={{ padding: '1px 1px 0 1px' }}></span></a>
            </div>
        </div>
    )

    renderTools = () => (
        <div className="toolbox-group hidden-xs">
            <p className="panel-name"><Translate id="Charts.Tools" /></p>
            <div id="toolController" className="content">
                <a id="overviewToggle" className="rc-button-frame rc-checkbox" title={this.props.translate("Charts.NavigateWindow")} onClick={this.props.toggleOverview}><span className="rc-button icon-rc rc-navigator" style={{ padding: '1px 1px 0 1px' }}></span></a>
                <a id="magnifierToggle" className="rc-button-frame rc-checkbox" title={this.props.translate("Charts.ShowMagnifier")} onClick={this.props.toggleMagnifier}><span className="rc-button icon-rc rc-magnifying-glass" style={{ padding: '1px 1px 0 1px' }}></span></a>
            </div>
        </div>
    )

    renderDisplayOptions2 = () => (
        <div className="toolbox-group hidden-xs">
            <p className="panel-name"><Translate id="Charts.DisplayOptions" /></p>
            <div className="content" style={{ paddingTop: '5px' }}>
                <div className="checkbox" style={{ margin: '0 5px 0 5px' }} onClick={this.props.toggleRelationLabels} >
                    <input type="checkbox" id="relationLabelsCheckbox" checked={this.props.topPanel.linkLabels} readOnly />
                    <label><Translate id="Charts.ShowRelationCaptions" /></label>
                </div>
                <div className="checkbox" style={{ margin: '0 5px 0 5px' }} onClick={this.props.toggleProfiVersion} >
                    <input type="checkbox" id="profiVersionNiCheckboxViewer" checked={this.props.topPanel.isProfi} readOnly />
                    <label><Translate id="Charts.ShowNewPictograms" /></label>
                </div>
            </div>
        </div>
    )

    renderProfileSelection = () => {
        if (this.props.profiles === undefined) { return ''; }
        const keys = Object.keys(this.props.profiles);
        if (keys === null || keys === undefined || keys.length !== 2) { return ''; }
        return (
            <div className={classnames('toolbox-group hidden-xs', { 'disabled': this.props.mode === GRAPH_MODE.path })} >
                <p className="panel-name"><Translate id="Charts.Profile" /></p>
                <div className="content" id="profileController">
                    <select id="profileSelector" className="rc-button-frame" style={{ width: '75px', height: '32px', fontSize: '12.5px' }} onClick={(e) => this.isDoubleclick(e)} disabled={this.props.mode === GRAPH_MODE.path}>
                        {keys.map(k => <option key={k} value={k}>{this.props.profiles[k].label}</option>)}
                    </select>
                    <a className={classnames('rc-button-frame rc-button-text', { 'disabled': this.props.mode === GRAPH_MODE.path })} style={{ textAlign: 'center' }} onClick={this.props.useProfile}><span style={{ padding: '0 5px' }}><Translate id="Charts.ProfileUse" /></span></a>
                    <a className={classnames('rc-button-frame rc-button-text', { 'disabled': this.props.mode === GRAPH_MODE.path })} style={{ textAlign: 'center' }} onClick={this.props.saveProfile}><span style={{ padding: '0 5px' }}><Translate id="Charts.ProfileSetUp" /></span></a>
                </div>
            </div>
        );
    }

    isDoubleclick = (e) => {
        if (this.doubleClickHookTimestamp == null) {
            this.doubleClickHookTimestamp = e.timeStamp;
            //_doubleClickHookItemId = $('select#profileSelector').val();
            return false;
        }

        if (e.timeStamp - this.doubleClickHookTimestamp > 250) {
            this.doubleClickHookTimestamp = e.timeStamp;
            //_doubleClickHookItemId = $('select#profileSelector').val();
            return false;
        }

        this.doubleClickHookTimestamp = null;
        this.renamePopup();
    }

    renamePopup = () => {
        this.props.showPopup('renameProfilePopup', { open: true, close: () => this.props.hidePopup(), oldName: this.props.profiles[document.getElementById('profileSelector').value].label, saveName: (name) => this.saveName(name) });
    }

    saveName = (name) => {
        this.props.renameProfile(name);
        this.props.hidePopup();
    }

    renderVisualization = () => {
        return (
            <div className="toolbox-group hidden-xs">
                <p className="panel-name"><Translate id="Charts.Visualization" /></p>
                <div className="content" id="visualizationController">
                    {!isNullOrUndefined(this.props.visualizations.loadedVisualization) && this.props.visualizations.loadedVisualization.isStatic && this.renderVisualizationButton("Common.UpdateAll", () => this.props.reloadVisualization(), RefreshIcon, true)}
                    {!isNullOrUndefined(this.props.visualizations.loadedVisualization) && this.renderVisualizationButton("Common.Save", () => this.props.saveVisualization(), SaveIcon, true)}
                    {this.renderVisualizationButton("Charts.Visualization.SaveAs.Button", () => this.saveVisualizationPopup(), SaveAsIcon)}
                    {this.renderVisualizationButton("Charts.Visualization.Load.Button", () => this.loadVisualizationPopup(), LoadIcon)}
                </div>
            </div>
        )
    }

    renderVisualizationButton = (titleKey, onClickFunc, icon, withSaving = false) => {
        let ButtonIcon = icon;
        return (
            <a className={this.getExportButtonClasses()}
                title={this.props.translate(titleKey)}
                onClick={() => onClickFunc()}
            >
                {withSaving && this.props.visualizations.saving && <span className="rc-icon rc-waiting" />}
                <ButtonIcon className='icon-centered' width="24px" height="24px" />
            </a>
        )
    };

    saveVisualizationPopup() {
        this.props.showPopup('saveVisualizationPopup', { open: true, close: () => this.props.hidePopup() })
    }
    loadVisualizationPopup() {
        var idsParam = this.props.match.params.id;
        if (idsParam.indexOf('?') !== -1) {
            idsParam = idsParam.substring(0, idsParam.indexOf('?'));
        }
        const ids = idsParam.split(',').map(x => parseInt(x));
        this.props.showPopup('loadVisualizationPopup', { ids: ids, open: true, close: () => this.props.hidePopup() })
    }

    renderExport = () => {
        return (
            <div className="toolbox-group hidden-xs">
                <p className="panel-name"><Translate id="Charts.ExportSection" /></p>
                <div className="content" id="exportController">
                    {this.renderExportButtonWithPover("Charts.ExportToXLSX", () => this.props.exportToXlsx(chartExportTypes.xlsxFull), chartExportTypes.xlsxFull, "rc-export-xlsx")}
                    {hasPermission(null, "RCexportCSV") && this.renderExportButtonWithPover("Charts.ExportToCSV", () => this.props.exportToCsv(chartExportTypes.csvSl), chartExportTypes.csvSl, "rc-export-csv")}
                    {this.renderExportButtonWithPover("Charts.ExportToPDF", () => this.props.exportToPdf(), chartExportTypes.pdf, "rc-export-pdf")}
                    {this.renderExportButton("Charts.ExportToPrint", () => this.props.exportToPdf(true), chartExportTypes.printPdf, "rc-export-print")}
                    {this.renderExportButton("Charts.ExportToPNG", () => this.props.exportToPng(this.getExportTranslations()), chartExportTypes.png, "rc-export-png")}
                    {this.renderExportButton("Charts.ExportToSVG", () => this.props.exportToSvg(this.getExportTranslations()), chartExportTypes.svg, "rc-export-svg")}
                </div>
            </div>
        );
    }

    renderExport2 = () => {
        return (
            <div className="toolbox-group hidden-xs">
                <p className="panel-name"><Translate id="Charts.Print" /></p>
                <div className="content" id="printController">
                    <a className={this.getExportButtonClasses()} title={this.props.translate("Charts.PrintGraph")} onClick={() => this.props.exportToPrintDiagram(this.getExportTranslations())}                    >
                        <span className="rc-button icon-rc rc-print" style={{ padding: '1px 1px 0 1px' }}></span>
                    </a>
                </div>
            </div>
        );
    }

    renderExportButtonWithPover = (titleKey, onClickFunc, exportType, exportTypeClass) => {
        const exportUsed = this.props.exports.exportUsed.includes(exportType);
        return (
            <BbPopover
                content={this.props.translate('Common.Button.ExportPdf.Processing')}
                placement="top"
                targetId={`rc-top-export-button-${exportType}`}
                toggleOnEvent={exportUsed ? "toggleOnMouse" : "toggleNever"}
                withDelayAfterFirstToggle
            >
                {this.renderExportButton(titleKey, onClickFunc, exportType, exportTypeClass, true)}
            </BbPopover>
        );
    }

    renderExportButton = (titleKey, onClickFunc, exportType, exportTypeClass, checkIfUsed = false) => {
        const exportUsed = checkIfUsed && this.props.exports.exportUsed.includes(exportType);
        return (
            <a id={`rc-top-export-button-${exportType}`} className={classnames(this.getExportButtonClasses(), { 'is-disabled': exportUsed })} title={this.props.translate(titleKey)}
                onClick={() => exportUsed ? undefined : onClickFunc()}
            >
                {this.props.exports.exporting === exportType && <span className="rc-icon rc-waiting" />}
                <span className={classnames(`rc-button icon-rc ${exportTypeClass}`, { 'is-disabled': exportUsed })} style={{ padding: '1px 1px 0 1px' }}></span>
            </a>
        );
    }

    getExportTranslations() {
        return {
            reportDate: this.props.translate("Charts.Report.Date"),
            shortName: this.props.translate("Charts.Report.BusinessCharts.ShortName"),
            disclaimerCz: this.props.translate("Charts.DisclaimerCZ"),
            disclaimerSk: this.props.translate("Charts.DisclaimerSK"),
            username: this.props.translate("Username.Label"),
            removedSubjects: this.props.translate("Charts.ExportRemovedSubjects"),
            yes: this.props.translate("Common.Yes"),
        };
    }

    getExportButtonClasses = () => {
        return classnames({
            "rc-button-frame": true,
            "hidden-xs": true,
            "rc--overlay": this.props.exports.exporting !== null,
            "rc-waiting-overlay": this.props.exports.exporting !== null,
            "disabled": this.props.exports.exporting !== null
        });
    }

    renderLegend = () => (
        <div className="toolbox-group hidden-xs">
            <p className="panel-name"><Translate id="Charts.LegendsToolTip" /></p>
            <div className="content">
                <a className="rc-button-frame" onClick={() => this.legendPopup()}><span className="rc-button icon-rc rc-explanations"></span></a>
            </div>
        </div>
    )

    legendPopup = () => {
        this.props.showPopup('legendPopup', { open: true, close: () => this.props.hidePopup() });
    }

    renderRightPanel = () => (
        <div className="toolbox-group hidden-sm hidden-md hidden-lg" style={{ float: 'right' }}>
            <p className="panel-name hidden-xs"><Translate id="Charts.FilterSection" /></p>
            <div id="typeController" className="content">
                <a onClick={_ => this.props.toggleRightPanel(true, 'chart-settings')} className="rc-button-frame" title={this.props.translate("Charts.FilterSection")}>
                    <FontAwesomeIcon id="btnFilter" icon={'bars'} style={{ fontSize: '32px', paddingTop: '5px' }} />
                </a>
            </div>
        </div>
    )
}


export default withRouter(withLocalize(connect(
    state => state.charts,
    dispatch => bindActionCreators(({ ...chartActions, ...popupActions, ...rightPanelStoreActions }), dispatch)
)(ChartTopPanelComponent)));
